<template>
  <v-container row wrap class="text-white">
    <v-dialog v-model="dialog" max-width="500" :persistent="persistent">
      <v-card class="orangeTop">
        <v-card-title>
          <v-icon class="warning-icon text-warning mr-3" :icon="mdiAlert" />
          <span class="font-size--20 fontWeight600">{{
            $t('L_are_you_sure_you_want_to_leave_this_page')
          }}</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            {{ $t(navigationDialogBody) }}
          </v-container>
        </v-card-text>
        <v-divider />
        <v-card-actions>
          <v-spacer />
          <v-container class="d-flex align-center justify-end">
            <v-col cols="6">
              <OnexButton color="primary" @click="funcRouteAway" block>
                {{ $t('L_yes_leave') }}
              </OnexButton>
            </v-col>
            <v-col cols="6">
              <OnexButton color="primary" @click="funcStayOnPage" block>
                {{ $t('L_stay_on_page') }}
              </OnexButton>
            </v-col>
          </v-container>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script lang="ts">
import { mapState, mapActions } from 'pinia';
import { useGlobalStore } from '@/stores/global/global.store';
import { usePolicyStore } from '@/modules/policy/store/policy.store';
import { defineComponent, type ComponentOptions } from 'vue';
import { OnexButton } from '@primerica/onex-ui-lib';
import { mdiAlert } from '@mdi/js';
import { RouteNames } from '@/router/routeNames.ts';

const componentOptions: ComponentOptions = {
  name: 'NavigationConfirmation',
  components: {
    OnexButton,
  },
  data: () => ({
    dialog: true,
    persistent: true,
    mdiAlert,
  }),
  computed: {
    ...mapState(useGlobalStore, ['navigationDialogBody', 'getNavigationPathOnUserConfirmation']),
    ...mapState(usePolicyStore, {
      policies: 'policies',
      // beneficiaryStep: 'beneficiaryStep',
      paymentStep: 'paymentStep',
      // withDrawalDateStep: 'withDrawalDateStep',
    }),
  },
  methods: {
    ...mapActions(usePolicyStore, {
      setBeneficiaryStep: 'setBeneficiaryStep',
      setPaymentStep: 'setPaymentStep',
      setWithDrawalDateStep: 'setWithDrawalDateStep',
    }),
    ...mapActions(useGlobalStore, {
      updateShowNavigationConfirmation: 'updateShowNavigationConfirmation',
    }),

    async funcRouteAway() {
      // First we are defaulting state for Beneficiary Navigation to -1 so that it won't go back to
      // confirm dialog again
      // This is a custom one for beneficiary
      // if (this.beneficiaryStep !== -1) {
      //   this.setBeneficiaryStep(-1);
      // }
      if (this.paymentStep !== -1) {
        await this.$router.push({ name: RouteNames.POLICY_DETAILS });

        // Setting -2 here and 3 in the BootStrapGuard so that it is not refreshing page to hide Payment Wizard and showing Policy Page as they both are on same page.
        this.setPaymentStep(-2);
      }
      // if (this.withDrawalDateStep !== -1) {
      //   this.setWithDrawalDateStep(-1);
      // }
      // This is common code for all
      if (
        this.getNavigationPathOnUserConfirmation?.name !== '' &&
        this.getNavigationPathOnUserConfirmation?.name !== undefined
      ) {
        this.$router.push({ name: this.getNavigationPathOnUserConfirmation.name });
      } else if (
        this.getNavigationPathOnUserConfirmation?.path !== '' &&
        this.getNavigationPathOnUserConfirmation?.path !== undefined
      ) {
        this.$router.push({ path: this.getNavigationPathOnUserConfirmation.path });
      }
      this.updateShowNavigationConfirmation(false);
      // This is to not display Pay Now if user goes to Policy Details
      this.setPaymentStep(-1);
    },
    funcStayOnPage() {
      this.updateShowNavigationConfirmation(false);
    },
  },
};
export default defineComponent(componentOptions);
</script>
<style lang="scss" scoped>
.close {
  float: right;
}
.orangeTop {
  border-top: 7px solid #ee7026;
}
.fontWeight600 {
  font-weight: 600;
}
</style>
